/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class ShareExpense extends React.PureComponent {
  render() {
    const { value, label, onChange } = this.props

    return (
      <Form.Field>
        <label>{label}</label>
        <Input
          label={{ content: '%' }}
          labelPosition="right"
          placeholder="e.g 10"
          type="number"
          onChange={e => onChange(e.target.value)}
          value={value}
          step={0.1}
          min={0}
          max={100}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/shareExpense.js